import { Box, Grid, Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EirInformation from '../eir-information/EirInformation';
import EirOrderSummaryFooter from './EirOrderSummaryFooter';
import EirEmptyCart from '../eir-empty-cart/EirEmptyCart';
import EirDepositTooltip from '../eir-tooltip/EirDepositTooltip';
import styles from './style';
import EirOrderSummaryBreakdown from './EirOrderSummaryBreakdown';
import EirSummary from './EirSummary';
import localCmsData from '../../../util/cmsData.util';

const EirOrderSummary = ({
  cmsData,
  loading,
  cartData,
  cartInfo,
  tacticalOffers,
  getClickedItem,
  openConfirmationModal,
  openClearCartConfirmationModal,
  isCurrentServiceComplete,
  isPortingComplete,
  emptyCart,
  systemAddedOffer,
  setHasMissingStep = () => {},
  setIncompleteCart,
  incompleteCart,
  pSIMCode,
  refreshSummary,
}) => {
  const [deleteIcon] = useState(true);
  const summaryData = localCmsData();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down('md'));

  const getClearConfirmationModal = () => {
    openClearCartConfirmationModal.enable();
  };

  // React.useEffect(() => {
  //   console.log(setHasMissingStep);
  // }, [setHasMissingStep]);
  if (loading) {
    return (
      <Grid
        container
        maxWidth='md'
        sx={{ pt: 4, pb: 4, m: '0 auto' }}
        justifyContent='center'
        // spacing={{ md: 4 }}
      >
        <Grid item xs={12} md={10}>
          <Stack alignItems='center' sx={{ p: { xs: 1, md: '0 1rem' } }}>
            <Skeleton sx={{ mb: { xs: 1, md: 4 }, width: { xs: 200, md: 400 }, height: 48 }} />
            <Skeleton width={250} height={24} sx={{ mb: 2 }} />
          </Stack>
        </Grid>
        <Grid item xs={12} md={10} container>
          {Array(7)
            .fill()
            .map((_, i) => (
              <Grid key={i} item xs={12} md={6}>
                <Skeleton
                  variant='rectangular'
                  width='80%'
                  height={40}
                  sx={{ m: '0.5rem auto 0' }}
                />
              </Grid>
            ))}
        </Grid>
        <Grid item xs={12} md={10}>
          <Stack alignItems='flex-end' sx={{ p: '0 1rem', mt: 2 }}>
            <Stack direction='row'>
              <Skeleton width={60} height={23} />
              <Skeleton width={20} height={23} sx={{ ml: 1, mb: 1 }} />
            </Stack>
            <Skeleton width={150} height={40} variant='rectangular' sx={{ borderRadius: 20 }} />
          </Stack>
        </Grid>
      </Grid>
    );
  }
  return !emptyCart && cartInfo.haveOffer ? (
    <>
      <Grid container maxWidth='100%' justifyContent='center'>
        <Grid item xs={12} sm={12} sx={styles(theme).summaryTitle}>
          <EirInformation
            title={cmsData?.attributes?.EirInformation_OrderSummary?.title}
            description={cmsData?.attributes?.EirInformation_OrderSummary?.description}
            textAlign={cmsData?.attributes?.EirInformation_OrderSummary?.textAlign}
            style={{
              title: { color: theme.palette.primary.textColor3 },
            }}
            makeH1
            useH1={cmsData?.attributes?.EirInformation_OrderSummary?.useH1}
          />
        </Grid>
      </Grid>
      <Grid container columnSpacing={2} sx={styles(theme).myCart}>
        <Grid item xs={12} md={6} sx={{ marginBottom: md ? '24px' : '0px' }}>
          <EirSummary
            summaryData={summaryData}
            cartData={cartData}
            tacticalOffers={tacticalOffers}
            loading={loading}
            deleteIcon={deleteIcon}
            openConfirmationModal={openConfirmationModal}
            getClickedItem={getClickedItem}
            isCurrentServiceComplete={isCurrentServiceComplete}
            isPortingComplete={isPortingComplete && !cartData.isPortInDone}
            setHasMissingStep={setHasMissingStep}
            systemAddedOffer={systemAddedOffer}
            setIncompleteCart={setIncompleteCart}
            cmsData={cmsData?.attributes}
            pSIMCode={pSIMCode}
            refreshSummary={refreshSummary}
          />
          {!md && (
            <Grid item xs={12} sm={12}>
              <Box sx={styles(theme).clearCartContainer}>
                <Box
                  role='button'
                  tabIndex={0}
                  onClick={getClearConfirmationModal}
                  onKeyDown={e => {
                    if (e.key === ' ') {
                      e.preventDefault(); // stop Space from scrolling
                    }
                  }}
                  onKeyUp={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      getClearConfirmationModal(); // activate on keyup
                    }
                  }}
                  aria-label='Clear cart'
                  sx={styles(theme).clearCartItem}
                >
                  <Typography variant='body2' sx={styles(theme).clearCartText}>
                    Clear cart
                  </Typography>
                  <DeleteForeverIcon sx={styles(theme).clearCartIcon} />
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <EirOrderSummaryBreakdown
            summaryData={summaryData}
            loading={loading}
            cartData={cartData}
            cartInfo={cartInfo}
          />
          {md && (
            <Grid item xs={12} sm={12}>
              <Box sx={styles(theme).clearCartContainer}>
                <Box
                  role='button'
                  tabIndex={0}
                  onClick={getClearConfirmationModal}
                  onKeyDown={e => {
                    if (e.key === ' ') {
                      e.preventDefault(); // stop Space from scrolling
                    }
                  }}
                  onKeyUp={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      getClearConfirmationModal(); // activate on keyup
                    }
                  }}
                  aria-label='Clear cart'
                  sx={styles(theme).clearCartItem}
                >
                  <Typography variant='body2' sx={styles(theme).clearCartText}>
                    Clear cart
                  </Typography>
                  <DeleteForeverIcon sx={styles(theme).clearCartIcon} />
                </Box>
              </Box>
            </Grid>
          )}
          {(cartData?.hasBillPayPlans || cartData?.hasMBBOffer) && (
            <Grid item xs={12} sm={12} sx={{ pt: 2 }}>
              <EirDepositTooltip hasMBBOffer={cartData?.hasMBBOffer} />
            </Grid>
          )}
          <Grid item xs={12} sm={12} sx={styles(theme).myCartSection}>
            {/* Disabling continue button when schedule port is not done for portin Offers  */}
            <EirOrderSummaryFooter
              isCurrentServiceComplete={isCurrentServiceComplete}
              isPortingComplete={isPortingComplete}
              isPorting={cartData.isPortInDone}
              cartData={cartData}
              cartInfo={cartInfo}
              incompleteCart={incompleteCart}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  ) : (
    <EirEmptyCart />
  );
};

export default EirOrderSummary;
